<template>
    <BaseTooltipHelp
        :theme="theme"
        data-spec-class="tooltip-help-business-hours"
    >
        {{ tooltipText }}
    </BaseTooltipHelp>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Theme } from '@/types';
import BaseTooltipHelp from '@/components/BaseTooltipHelp.vue';
import { getGermanyTimeZoneKey, getGermanyUtcDifference } from '@/utils/timeUtils';

const { t } = useI18n();

interface Props {
    theme?: Theme;
}

withDefaults(defineProps<Props>(), {
    theme: Theme.Dark,
});

const tooltipText = computed(() => {
    const now = new Date();
    const timeZone = t(`general.timezones.${getGermanyTimeZoneKey(now)}`);
    const utcDifference = getGermanyUtcDifference(now);

    return t('pages.DashboardPage.serviceTeaser.info', {
        timeZone,
        utcDifference,
    });
});
</script>
